import React, { useState } from "react"
import PrimeTable from "../PrimeTable/PrimeTable"

import mainAxios from '../../services/mainAxios'

import "react-datepicker/dist/react-datepicker.css"
import { toast } from "react-toastify"
import Loader from "../Layout/Loader"

import { useTranslation } from "react-i18next";
import CellInput from "../global/CellInput"

const TaxPayers = () => {

    const { t } = useTranslation('translations');
    const [inputValue,setInputValue] = useState("")
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false);
    const [taxPayers, setTaxPayers] = useState([])


    const getFilteredResults = () => {
        if(inputValue?.length==0) return
        setLoading(true)
        setError(null)
            const isNIPT = new RegExp("[a-zA-Z]{1}[0-9]{8}[a-zA-Z]{1}").test(inputValue);
            const content = isNIPT
            ? {
                object: "GetTaxpayersRequest",
                value:inputValue,
                }
            : {
                object: "GetTaxpayersRequest",
                params: { name: inputValue},
                }

            mainAxios.post('apiEndpoint/search', content).then(res => {
                if (res?.data?.status === true) {
                    setTaxPayers(res.data.content)
                    if (res.data.content.length === 0) toast.warning(t(['toast.noTaxPayer']), { containerId: "all_toast" })
                }
                else {
                    setTaxPayers([])
                }
                setLoading(false)
            }).catch(e => {
                setLoading(false)
            })
    }


    const columns = [
        {
            header: t(['taxpayer.taxpName']),
            field: 'name',
            sortable: true,
            filter: true,
            style: { minWidth: '300px', maxWidth: '350px' },
            body: (row) => <CellInput value={row?.name ?? ""} width={300} />,
        },
        {
            header: 'NIPT',
            field: 'tin',
            sortable: true,
            filter: true,
            style: { minWidth: '150px', maxWidth: '200px' },
        },
        {
            header: t(['taxpayer.country']),
            field: 'country',
            sortable: true,
            filter: true,
            style: { minWidth: '150px', maxWidth: '200px' },
        },
        {
            header: t(['taxpayer.town']),
            field: 'town',
            sortable: true,
            filter: true,
            style: { minWidth: '150px', maxWidth: '200px' },
        },
        {
            header: t(['taxpayer.address']),
            field: 'address',
            sortable: true,
            filter: true,
            style: { minWidth: '400px', maxWidth: '600px' },
            body: (row) => <CellInput value={row?.address ?? ""} width={400} />,
        }
    ];



    const headerButtonsLeft = (
        <form onSubmit={(e) => { e.preventDefault(); getFilteredResults() }} className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
            <input
                className="form-control form-control-sm"
                placeholder={`Nipt/${t("common.businessName")}`}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
            />
            <button
                className="btn btn-sm btn-primary"
                disabled={loading}
                style={{ minWidth: "80px" }}
                onClick={() => getFilteredResults()}>
                {loading ? <Loader size="xs" /> : t(['navbar.search'])}
            </button>
        </form>
    );

    return (
        <PrimeTable
            columns={columns}
            value={[...taxPayers]}
            simpleTable={true}
            showSelectColumns={false}
            clearFilters={false}
            headerButtonsLeft={headerButtonsLeft}
        />
    )
}

export default TaxPayers